import {
  createRootRoute,
  createRoute,
  createRouter,
  Navigate,
} from "@tanstack/react-router";
import { InternalChatPage } from "./lazy-pages";
import { AccountPage } from "./pages/account";
import { DashboardPage } from "./pages/dashboard";
import { LoginPage } from "./pages/login";
import { ModulePage } from "./pages/module-page";
import { UsersPage } from "./pages/users";
import { ProtectedLayout, RootComponent } from "./router-layout";
import { RouteError } from "./components/route-error";

const rootRoute = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <Navigate to="/dashboard" replace />,
});
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: LoginPage,
});
const protectedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "_protected",
  component: ProtectedLayout,
});
const dashboardRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/dashboard",
  component: DashboardPage,
});
const usersRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/users",
  component: UsersPage,
});
const accountRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/account",
  component: AccountPage,
});
const chatRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/chat",
  component: InternalChatPage,
});
const moduleRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/modules/$moduleId",
  component: ModulePage,
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  protectedRoute.addChildren([
    dashboardRoute,
    usersRoute,
    accountRoute,
    chatRoute,
    moduleRoute,
  ]),
]);

export const router = createRouter({
  defaultErrorComponent: RouteError,
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
